import { parse } from 'querystring';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import * as styles from './ConnectExternalIdentity.module.scss';
import Logger from '../../utils/Logger';
import request from '../../utils/network/request';

const ConnectExternalIdentity = () => {
  const params = useParams();
  const { platform } = params;
  const location = useLocation();
  const query = parse(location.search.substring(1));
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!platform) return;
    request(`/api/${platform}/connect_user`, 'GET', query)
      .then((data) => {
        document.location = (data as { url: string }).url;
      })
      .catch((error) => {
        Logger.error("Couldn't get external connect_user URL", {
          query,
          error,
        });
        setHasError(true);
      });
  }, [platform, query]);

  return (
    <div className={styles.container}>
      {hasError
        ? 'Oops, something went wrong. Please try again or contact support.'
        : 'Loading…'}
    </div>
  );
};

export const ConnectIdentityStatus = () => {
  const location = useLocation();
  const query = parse(location.search.substring(1));
  useEffect(() => {
    setTimeout(() => window.close(), 5000);
  });

  const message = query.error
    ? 'There was a problem connecting your account to Slab.'
    : 'Successfully connected your account to Slab.';

  return (
    <div className={styles.pageCenter}>
      <h3>{message}</h3>
      <p>Please close this window if it doesn&apos;t close automatically.</p>
    </div>
  );
};

export default ConnectExternalIdentity;
